import React from 'react';
import PropTypes from 'prop-types';
import Image from 'semantic-ui-react/dist/commonjs/elements/Image';
import Input from 'semantic-ui-react/dist/commonjs/elements/Input';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';

import './forminputs.css';
import { Label } from './fomInput';
import { ERROR, INFO_TIMELINE_ICON } from '@Images';

class RenderTextField extends React.Component {
  inputFocus = () => {
    this.setState({ is_focus: true });
  };

  inputBlur = (e) => {
    this.props.input.value = e.target.value.trim();
    this.setState({ is_focus: false });
    this.props.input.onBlur(this.props.input.value);
  };

  keyDownEvent = (event) => {
    if (this.props.disableShortcut) {
      if (event.metaKey || event.ctrlKey) {
        event.preventDefault();
      }
    }
  };

  constructor(props) {
    super(props);
    this.state = { is_focus: false };
  }

  render() {
    const {
      input,
      disableCopyPaste,
      placeholder,
      className,
      type,
      tooltip,
      disabled,
      tip,
      maxLength,
      showError,
      errFromParent,
      parentClassName = '',
      meta: { touched, error, warning },
      getInputRef,
      isEditable,
      parentComponent,
      showErrorIcon,
      isCorporateCoupon = false,
      isVisaCardEditCase,
      showLabel = false,
      labelText
    } = this.props;
    let inputWarperClassName = !isEditable
      ? `render-text-field ${parentClassName} ${disabled ? 'disabled' : ''}`
      : `render-text-field-edit ${parentClassName}`;
    if (isCorporateCoupon) {
      inputWarperClassName = `${inputWarperClassName} corporate_coupon_field`;
    }
    return (
      <div className={inputWarperClassName}>
        <div className={'input-error-wrapper'}>
          {this.props.showDefaultPlaceholder && parentComponent !== 'SendMoneyUS' && !showLabel ? (
            //for Multi Txn currenct converter's label
            <Label
              className={`text-visible-label ${isVisaCardEditCase ? 'placeholder_margin' : ''}`}
            >
              {' '}
              {placeholder}{' '}
            </Label>
          ) : input.value && parentComponent !== 'SendMoneyUS' && !showLabel ? (
            <Label className={`${isVisaCardEditCase ? 'placeholder_margin' : ''}`}>
              {' '}
              {placeholder}{' '}
            </Label>
          ) : showLabel && error && touched ? (
            <Label className="label-error">{labelText ? labelText : placeholder}</Label>
          ) : showLabel && labelText ? (
            <Label> {labelText ? labelText : placeholder} </Label>
          ) : (
            ''
          )}
          <Input
            loading={this.props.showLoader || false}
            {...input}
            id={(this.props.id || input.name || '').replace(/[._]/g, '-').toLowerCase()}
            className={
              parentComponent !== 'SendMoneyUS' && showLabel && error && touched
                ? 'input-error'
                : parentComponent !== 'SendMoneyUS'
                ? className
                : ''
            }
            placeholder={placeholder}
            type={type}
            onFocus={this.inputFocus}
            onBlur={this.inputBlur}
            disabled={disabled || false}
            onKeyDown={this.keyDownEvent}
            maxLength={maxLength || '1000'}
            onPaste={(e) => (disableCopyPaste || false) && e.preventDefault()}
            onCopy={(e) => (disableCopyPaste || false) && e.preventDefault()}
            onCut={(e) => (disableCopyPaste || false) && e.preventDefault()}
            autoComplete={this.props.autoComplete || 'on'}
            ref={(ref) => (getInputRef ? getInputRef(ref) : this.props.ref)}
          />
          {!this.props.disableUnderlineStyling && parentComponent !== 'SendMoneyUS' && (
            <span
              className="bar"
              style={{ display: this.state.is_focus ? 'block' : 'none' }}
            ></span>
          )}
          {((showError !== false && touched && error) || errFromParent) && (
            <div className="error-msg"> {error || errFromParent} </div>
          )}
          {((showError !== false && touched && error) || errFromParent) && showErrorIcon && (
            <Image src={ERROR} className="info-icon" />
          )}
          {tip && !(touched && error) && <div className="tip-input-field">{tip}</div>}
          {touched && warning && (
            <div className="tooltip">
              <span className="tooltiptext"> {warning}</span>
            </div>
          )}
          {tooltip && (
            <Popup
              trigger={<Image src={INFO_TIMELINE_ICON} className="info-icon" />}
              content={tooltip}
              size="tiny"
              position="right center"
            />
          )}
        </div>
      </div>
    );
  }
}

RenderTextField.propTypes = {
  showError: PropTypes.any,
  parentComponent: PropTypes.any,
  id: PropTypes.string,
  input: PropTypes.any,
  placeholder: PropTypes.string,
  meta: PropTypes.any,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  type: PropTypes.any,
  tooltip: PropTypes.string,
  tip: PropTypes.any,
  showLoader: PropTypes.bool,
  disableUnderlineStyling: PropTypes.bool,
  disabled: PropTypes.any,
  EventKeyDown: PropTypes.func,
  disableShortcut: PropTypes.bool,
  maxLength: PropTypes.string,
  ref: PropTypes.any,
  disableCopyPaste: PropTypes.bool,
  errFromParent: PropTypes.string,
  showDefaultPlaceholder: PropTypes.bool,
  autoComplete: PropTypes.string,
  getInputRef: PropTypes.any,
  isEditable: PropTypes.any,
  showErrorIcon: PropTypes.bool,
  isCorporateCoupon: PropTypes.bool,
  isVisaCardEditCase: PropTypes.bool,
  showLabel: PropTypes.bool,
  labelText: PropTypes.string
};

export default RenderTextField;
